import {
    includedLocalCtsCenters,
    getSelectedCenter,
    isOnlyUsaSalesOrg,
    isUsaOrCanada,
    isOnlyCanada, isOnlyUsa
} from '../centers/reducers'

export const initState = {
    isLoading: false,
    mainParams: {
        materials: null,
        catalog: null,
        pricingGroup: null,
        soleriaColors: null
    },
    secondaryParams: null,
    preOrdersCts: [],
    preOrdersCurrentPage: 1,
    preOrdersLastPage: 1,
    preOrdersProjectAvailables: [],
    isSending:false,
    //Configurable bathrooms
    configurableModels: [],
    configurableDrawingList: {},
    favoriteConfigurations: {
        content: [],
        currentPage: 0,
        totalPages: 0,
        totalElements: 0
    },
    preOrderDetail: null,
    showPreOrderCommunicationAlert: false,
    communicationError: null,
    fastDeliveryData: null,
}

// 7532	Cosentino Brisbane
// 7536	Cosentino Hub Sydney
// 7535	Cosentino Melbourne North
export const EXTENDED_AU_LOCAL_CTS_CENTERS = ['7532', '7535', '7536']

// export const THREE_WEEKS_CENTERS = [
//     '7080', '7095', '7701', '7703', '7704', '7705', '7706', '7707', '7708', '7710', '7712', '7713', '7714', '7715', '7716', '7717', '7718', '7719', '7728', '7729', //Iberia
//     '7120', '7122', '7124', '7125', '7126', '7127', '7128', '7129', //Francia
//     '7030', '7031', '7032', '7034', '7035', '7036', '7037', '7041', //UK
//     '7050'/*Venecia*/, '7051'/*Milán*/, '7052'/*Turín*/, '7059'/*Florencia*/, '7060'/*Cattolica*/,
//     '7010', '7015', '7016', '7017', //Alemania
//     '7110', '7210', '7000', '7130', //Bélgica, Dinamarca, Holanda, Suiza
// ]
// export const FOUR_WEEKS_CENTERS = [
//     '7140', '7280', '7270', '7240', //Austria, Chequia, Lituania
//     '7241', '7242', '7243', //Polonia
//     '7100', '7101', //Suecia
//     '7065'/*Roma*/, '7053'/*Bari*/, '7054'/*Catania*/,
//     '7798', '7799' //Canarias
// ]
// export const FIVE_WEEKS_CENTERS = ['7220', '7160', '7162', '7038', '7150'] //Finlandia, Noruega, Irlanda, Belfast
// export const SEVEN_WEEKS_CENTERS = ['7180', '7181', '7182', '7201'] // Turquía e israhell
// export const EIGHT_WEEKS_CENTERS = ['7562', '7300', '7301'] //Dubai y Arabia



const cutToSize = (state = initState, action) => {
    switch (action.type) {
        case 'FETCH_CUT_TO_SIZE_MAIN_PARAMS_REQUEST':
            return { ...state, isLoading: true }

        case 'FETCH_CUT_TO_SIZE_MAIN_PARAMS_SUCCESS':
            return { ...state, mainParams: action.mainParams, isLoading: false }

        case 'RESET_CUT_TO_SIZE':
            return { ...state, mainParams: initState.mainParams, secondaryParams: null, isLoading: false }

        case 'FETCH_CUT_TO_SIZE_MAIN_PARAMS_FAILURE':
            return { ...state, mainParams: initState.mainParams, isLoading: false }

        case 'FETCH_CUT_TO_SIZE_SECONDARY_PARAMS_REQUEST':
            return { ...state, isLoading: true }

        case 'FETCH_CUT_TO_SIZE_SECONDARY_PARAMS_SUCCESS':
            return { ...state, secondaryParams: action.secondaryParams, isLoading: false }

        case 'FETCH_CUT_TO_SIZE_SECONDARY_PARAMS_FAILURE':
            return { ...state, secondaryParams: null, isLoading: false }
        case 'FETCH_PRE_ORDERS_CTS_FAILURE':
        case 'CUT_TO_SIZE_SEND_PREORDER_MESSAGE_FAILURE':
        case 'CUT_TO_SIZE_SEND_APPROVE_PREORDER_MESSAGE_FAILURE':
        case 'CUT_TO_SIZE_CANCEL_PREORDER_FAILURE':
            return { ...state, isLoading: false }

        case 'CUT_TO_SIZE_SEND_PREORDER_MESSAGE_SUCCESS':
        case 'CUT_TO_SIZE_SEND_APPROVE_PREORDER_MESSAGE_SUCCESS':
            let preorder = state.preOrdersCts.find(po => po.id === action.preorderId)
            if(!preorder){
                preorder = state.preOrderDetail
            }
            preorder.communications = action.communications
            preorder.files = action.files
            if (action.action === 'CUS_PLN_OK') preorder.status = 'ORDER_CREATED'
            return { ...state, isLoading: false }

        case 'CLEAR_PRE_ORDERS_CTS':
            return { ...state, preOrdersCts: [] }

        case 'FETCH_PRE_ORDERS_CTS_REQUEST':
        case 'CUT_TO_SIZE_SEND_PREORDER_MESSAGE':
        case 'CUT_TO_SIZE_SEND_APPROVE_PREORDER_MESSAGE':
        case 'CUT_TO_SIZE_CANCEL_PREORDER':
            return { ...state, isLoading: true }
        case 'FETCH_PRE_ORDERS_CTS_SUCCESS':
            return {
                ...state,
                preOrdersCts: action.ordersCurrentPage > 1 ? state.preOrdersCts.concat(action.data) : action.data,
                isLoading: false,
                preOrdersCurrentPage: action.ordersCurrentPage,
                preOrdersLastPage: action.ordersLastPage
            }
        case 'FETCH_PRE_ORDER_DETAIL_SUCCESS':
            return { ...state, preOrderDetail: action.preOrder }
        case 'FETCH_PRE_ORDERS_CTS_PROJECT_AVAILABLES_SUCCESS':
            return { ...state, preOrdersProjectAvailables: action.projects }
        case 'CUT_TO_SIZE_PREORDER_REQUEST':
            return { ...state, isSending: true }
        case 'CUT_TO_SIZE_PREORDER_REQUEST_SUCCESS':
            return { ...state, isSending: false }
        case 'CUT_TO_SIZE_PREORDER_REQUEST_FAILURE':
            return { ...state, isSending: false }
        case 'FETCH_CONFIGURABLE_BATHS_MODELS_SUCCESS':
            return Object.assign({}, state, { configurableModels: action.configurableModels })
        case 'FETCH_CONFIGURABLE_DRAWING_SUCCESS':
            return {
                ...state,
                configurableDrawingList: {
                    ...state.configurableDrawingList,
                    [action.configurableDrawing.referenceCode]: {
                        exists: action.configurableDrawing.exists,
                        documentUrl: action.configurableDrawing.documentUrl
                    }
                }
            }
        case 'FETCH_FAVORITE_CONFIGURATIONS_REQUEST':
            return { ...state, isLoading: true }
        case 'FETCH_FAVORITE_CONFIGURATIONS_SUCCESS':
            return {
                ...state,
                isLoading: false,
                favoriteConfigurations: {
                    content: action.favoriteConfigurations.content,
                    currentPage: action.favoriteConfigurations.currentPage,
                    totalPages: action.favoriteConfigurations.totalPages,
                    totalElements: action.favoriteConfigurations.totalElements
                }
            }
        case 'FETCH_FAVORITE_CONFIGURATIONS_FAILURE':
            return { ...state, isLoading: false }
        case 'SHOW_PRE_ORDER_COMMUNICATION_ALERT':
            return { ...state, showPreOrderCommunicationAlert: true, communicationError: action.error }
        case 'HIDE_PRE_ORDER_COMMUNICATION_ALERT':
            return { ...state, showPreOrderCommunicationAlert: false, communicationError: null }
        case 'FETCH_FAST_DELIVERY_TIMES_SUCCESS':
            return { ...state, fastDeliveryData: action.fastDeliveryData }
        default:
            return state
    }
}

export const isLoading = state => {
    return state.cutToSize.isLoading
}
export const getPreOrdersCts = state => {
    return state.cutToSize.preOrdersCts
}

export const getPreOrderById = (state,id) => {
    return state.cutToSize.preOrdersCts.find(item =>{ return item.id == id || item.id.toLowerCase() == id.toLowerCase()})
}
export const getCutToSizeMainParams = state => {
    return state.cutToSize.mainParams
}

export const getCutToSizeMaterials = state => {
    return state.cutToSize.mainParams.materials
}

export const getCutToSizeCatalog = state => {
    return state.cutToSize.mainParams.catalog
}

export const getCutToSizeSoleriaColors = state => {
    return state.cutToSize.mainParams.soleriaColors
}

export const getCutToSizeCustomerPricingGroup = state => {
    return state.cutToSize.mainParams.pricingGroup
}

export const getCutToSizeSecondaryParams = state => {
    return state.cutToSize.secondaryParams
}
export const getPreOrdersCurrentPage = state => {
    return state.cutToSize.preOrdersCurrentPage
}
export const getPreOrdersLastPage = state => {
    return state.cutToSize.preOrdersLastPage
}
export const getPreOrdersProjectAvailables = state => {
    return state.cutToSize.preOrdersProjectAvailables
}
export const getIsSending = state => {
    return state.cutToSize.isSending
}

export const getConfigurableModels = state => {
    return state.cutToSize.configurableModels
}

export const getConfigurableDrawingList = state => {
    return state.cutToSize.configurableDrawingList
}

export const canFilterQuickShip = state => {
    const currentCenter = getSelectedCenter(state).toString()
    return isOnlyUsa(state) || isOnlyCanada(state) || EXTENDED_AU_LOCAL_CTS_CENTERS.includes(currentCenter)
    // return isOnlyUsaSalesOrg(state) || (isUsaOrCanada(state) && state.login.impersonatedBy === 'DBU')
}

export const getFastDeliveryWeeks = state => {
    if (state.cutToSize.fastDeliveryData && state.cutToSize.fastDeliveryData !== 'NO_CONTENT' && state.cutToSize.fastDeliveryData.times) {
        return state.cutToSize.fastDeliveryData.times.fastDeliveryWeeks
    }
    return null
}

export const getRegularDeliveryWeeks = state => {
    if (state.cutToSize.fastDeliveryData && state.cutToSize.fastDeliveryData !== 'NO_CONTENT' && state.cutToSize.fastDeliveryData.times) {
        return state.cutToSize.fastDeliveryData.times.regularDeliveryWeeks
    }
    return null
}

export const getFavoriteConfigurations = state => {
    return state.cutToSize.favoriteConfigurations
}

export const getMarket = state => {
    const currentCenter = getSelectedCenter(state).toString()
    if (EXTENDED_AU_LOCAL_CTS_CENTERS.includes(currentCenter)) return 'AU'
    if (isOnlyUsa(state)) return 'USA'
    if (isOnlyCanada(state)) return 'CA'
    return 'HQ'
}

export default cutToSize
